// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1yY99","bigColWidth":"Table_bigColWidth__31x5J","biggerColWidth":"Table_biggerColWidth__2ztyu","row":"Table_row__cVFzl","col":"Table_col__1Jm7B"};